import { setLoginRedirectURL, getLoggedinUser, getOrgData } from "@/lib/auth";
import { getBackend } from "@/lib/backend/backend2";
import { getDeviceUUID } from "@/lib/util";

export type TrackingLocation = {
    pathname: string;
    search: string;
};

type TrackingEventPayload = Record<string, string | number | undefined>;

const LOGIN_REDIRECT_EXCLUDED_PATHS = new Set(["/login", "/change_password", "/activate_twofa"]);

async function sendTrackingEvent(payload: TrackingEventPayload): Promise<void> {
    try {
        await getBackend().tracking.createTrackingEvent(buildTrackingEventPayload(payload));
    } catch (error) {
        console.error("We got an error when sending tracking info ...", error);
    }
}

function buildTrackingEventPayload(basePayload: TrackingEventPayload): TrackingEventPayload {
    const payload: TrackingEventPayload = { ...basePayload };
    payload.device_id = getDeviceUUID();
    payload.rand = Math.random();
    payload.height = window.screen.height;
    payload.width = window.screen.width;
    const user = getLoggedinUser();
    if (user.uuid.length) {
        payload.user_uuid = user.uuid;
        const org = getOrgData();
        payload.org_uuid = org.uuid;
        payload.org_code = org.code;
    }

    return payload;
}

/**
 * Returns the path and query string used as the tracking payload `url` field
 * (`pathname` + `search`). Same-origin path only: no scheme, host, or hash.
 */
export function getTrackingUrl(location: TrackingLocation): string {
    return `${location.pathname}${location.search}`;
}

/** Tracks the current browser URL and stores it as a post-login redirect target when applicable. */
export function registerCurrentUrl(location: TrackingLocation): void {
    const currentURL = getTrackingUrl(location);
    if (!LOGIN_REDIRECT_EXCLUDED_PATHS.has(location.pathname)) {
        setLoginRedirectURL(currentURL);
    }

    void sendTrackingEvent({ url: currentURL, referer: window.location.href });
}
